<template>
    <div class="pp-lottery-winnings pp-lottery-winnings--centered">
        <DsTable>
            <DsRow>
                <DsCell type="th">Výherní pořadí</DsCell>
                <DsCell type="th">Uhodnuto (D+M+R)</DsCell>
                <DsCell type="th">Výherní násobek</DsCell>
            </DsRow>
            <DsRow v-for="(order, index) in winningOrdersGrid" :key="index">
                <DsCell>{{ index + 1 }}. pořadí</DsCell>
                <DsCell>{{ order[0] }}</DsCell>
                <DsCell><strong v-html="formatMultiple(order[1])"></strong></DsCell>
            </DsRow>
        </DsTable>
    </div>
</template>

<script lang="ts" setup>
import { StringUtils } from "@sazka/utils/string-utils";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";

const winningOrdersGrid: [string, number][] = [
    ["1 + 1 + 1", 10000],
    ["1 + 0 + 1", 200],
    ["0 + 1 + 1", 50],
    ["1 + 1 + 0", 20],
    ["0 + 0 + 1", 6],
    ["1 + 0 + 0", 2],
    ["0 + 1 + 0", 1],
];

const formatMultiple = (multiple: number) => `${StringUtils.formatNumber(multiple)}x`;
</script>
